import React from "react";
import toast from "react-hot-toast";
import { BsChatDotsFill } from "react-icons/bs";
import { IoMdClose } from "react-icons/io";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

const NewMessageToast = ({ t, id, name, content, type }) => {
    const { role } = useSelector((state) => state.auth);
    const navigate = useNavigate();

    const handleOnClickToast = () => {
        if (role === "ROLE_ADMIN") {
            navigate("/admin/dashboard/chat-sellers", { state: { sellerId: id } });
        } else {
            type === "admin"
                ? navigate("/seller/dashboard/chat-support")
                : navigate("/seller/dashboard/chat-customer", { state: { customerId: id } });
        }
        toast.dismiss(t.id);
    };

    return (
        <div
            className={`fixed top-4 right-4 flex flex-row bg-white rounded-lg shadow-lg p-4 items-center space-x-5 border border-gray-100 ${
                t.visible ? "animate-enter" : "animate-leave"
            }
        `}
        >
            <div
                className="flex flex-row items-center flex-1 space-x-3 cursor-pointer"
                onClick={handleOnClickToast}
            >
                <BsChatDotsFill className="size-7 text-blue-500" />
                <div className="flex flex-col space-y-1">
                    <p className="text-black font-semibold capitalize">{name}</p>
                    <p className="text-gray-500 text-sm capitalize">{content}</p>
                </div>
            </div>
            <button
                className="ml-auto text-gray-400 p-2 hover:text-gray-300 focus:outline-none cursor-pointer hover:bg-gray-100 rounded-full"
                onClick={() => toast.dismiss(t.id)}
            >
                <IoMdClose className="size-5 text-gray-400" />
            </button>
        </div>
    );
};

export default NewMessageToast;
